import enTrans from "./en/translation.json";
import thTrans from "./th/translation.json"

const locales = {
  en: { translation: enTrans, label: "English" },
  th: { translation: thTrans, label: "Thailand" },
};
export default locales;
